import type { ReactNode } from 'react';
import { Popup, Table } from 'semantic-ui-react';
import { DIFF_TYPE } from '../../../../../../../../../../constnats/diff';
import { EMPTY_DIFF_VALUE_LABEL } from '../../../../constants';
import type { DescriptorDiff } from '../../../../types';
import type { ColumnLabels } from '../../types';

type DescriptorCellProps = {
    label: string;
    tooltipContent: ReactNode;
    descriptorId: string;
    modelDiff?: DescriptorDiff;
    columnLabels: ColumnLabels;
    level?: number;
};

function DescriptorCell({ label, tooltipContent, descriptorId, modelDiff, columnLabels, level = 0 }: DescriptorCellProps) {
    const propertyDiffs = modelDiff?.propertyDiffs ?? [];
    const isChanged = modelDiff?.diffType === DIFF_TYPE.CHANGED;
    const labelContent = (
        <Popup
            on="hover"
            wide
            className="branch-comparison-details__descriptor-tooltip"
            content={tooltipContent}
            trigger={
                <span
                    className="branch-comparison-details__descriptor-label"
                    style={{ paddingLeft: `${level}em` }}
                >
                    {label}
                </span>
            }
        />
    );
    const trigger = (
        <td
            className={[
                'branch-comparison-details__column--descriptor',
                isChanged ? 'branch-comparison-details__cell--model-changed' : '',
                propertyDiffs.length ? 'branch-comparison-details__cell--changed' : '',
            ].filter(Boolean).join(' ')}
        >
            {labelContent}
        </td>
    );

    if (propertyDiffs.length === 0) {
        return trigger;
    }

    return (
        <Popup
            on="click"
            flowing
            className="branch-comparison-details__popup"
            trigger={trigger}
            content={
                <div className="branch-comparison-details__popup-content">
                    <strong>{label}</strong>
                    <div>Descriptor ID: {descriptorId}</div>
                    <Table compact celled size="small">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Property</Table.HeaderCell>
                                <Table.HeaderCell>{columnLabels.target}</Table.HeaderCell>
                                <Table.HeaderCell>{columnLabels.reference}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {propertyDiffs.map(({ propName, targetVal, referenceVal }) => (
                                <Table.Row key={propName}>
                                    <Table.Cell>{propName}</Table.Cell>
                                    <Table.Cell>{targetVal || EMPTY_DIFF_VALUE_LABEL}</Table.Cell>
                                    <Table.Cell>{referenceVal || EMPTY_DIFF_VALUE_LABEL}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            }
        />
    );
}

export default DescriptorCell;
